export const initialState: Redux.Alert = {
	alertType: 'info',
	content: null,
	isOpen: false,
	link: undefined,
};
